import { Model } from '@vuex-orm/core'


export default class EducationPlanPosition extends Model {
    static get entity () {
        return 'educationPlanPosition'
    }

    static get primaryKey () {
        return ['educationPlanId', 'positionId']
    }

    static fields () {
        return {
            educationPlanId: this.uid(),
            positionId: this.uid()
        }
    }
}
